/*
 * @描叙: 权限管理 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-03-04 09:30:27 
*/

import { $post } from '@/utils/http'
import Service from './Service'

// 获取权限分组
Service.getRoleGroupList = async function (params) {
    let request = {}
    // 管理员
    request['assigned_user_id'] = params.assigned_user_id;

    let data = await $post('/ucenter/v2/role/grop/dataset', request, true);
    return Service.handleCommonError(data)
}

// 添加权限分组
Service.getAddRoleGroup = async function (params) {
    let request = {}

    // 管理员
    request['assigned_user_id'] = params.assigned_user_id;
    // 权限分组名称
    request['groupname'] = params.groupname;
    // 分组使用情况，是否使用状态
    request['enable'] = params.enable;
    // 分组对应的权限
    request['allowed'] = JSON.stringify(params.allowed);

    let data = await $post('/ucenter/v2/role/grop/addgroup', request);
    return Service.handleCommonError(data)
}

// 根据分组唯一oid获取分组信息
Service.getRoleGroupInfo = async function (params) {
    let request = {}
    // 分组Id
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/role/grop/data', request, true);
    return Service.handleCommonError(data)
}

// 修改权限分组
Service.getEditRoleGroup = async function (params) {
    let request = {}
    
    // 管理员
    request['assigned_user_id'] = params.assigned_user_id;
    
    // 权限分组名称
    request['oid'] = params.oid;
    // 权限分组名称
    request['groupname'] = params.groupname;
    // 分组使用情况，是否使用状态
    request['enable'] = params.enable;
    // 分组对应的权限
    request['allowed'] = JSON.stringify(params.allowed);

    let data = await $post('/ucenter/v2/role/grop/editgroup', request);
    return Service.handleCommonError(data)
}

// 删除权限分组
Service.getDeletRoleGroup = async function (params) {
    let request = {}

    // 权限分组名称
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/role/grop/delgroup', request);
    return Service.handleCommonError(data)
}

// 权限模块API

// 	获取权限模块列表
Service.getRoleModuleList = async function () {
    let request = {}
    let data = await $post('/ucenter/v2/role/module/dataset', request, true);
    return Service.handleCommonError(data)
}

// 添加权限模块
Service.getAddRoleModule = async function (params) {
    let request = {}

    // 权限模块名称
    request['module_name'] = params.module_name;
    // 权限模块key
    request['module_key'] = params.module_key;
    // 权限模块排序
    request['order_id'] = params.order_id;
    // 分组使用情况，是否使用状态
    request['enable'] = params.enable;
    // 权限模块路由地址
    request['routing'] = params.routing;

    let data = await $post('/ucenter/v2/role/module/addmodule', request);
    return Service.handleCommonError(data)
}

// 修改权限模块
Service.getEditRoleModule = async function (params) {
    let request = {}

    // 权限模块oid
    request['oid'] = params.oid;
    // 权限模块名称
    request['module_name'] = params.module_name;
    // 权限模块排序
    request['order_id'] = params.order_id;
    // 分组使用情况，是否使用状态
    request['enable'] = params.enable;
    // 权限模块路由地址
    request['routing'] = params.routing;

    let data = await $post('/ucenter/v2/role/module/editmodule', request);
    return Service.handleCommonError(data)
}

// 删除权限模块
Service.getDeletRoleModule = async function (params) {
    let request = {}

    // 权限模块OID
    request['oid'] = params.oid;

    let data = await $post('ucenter/v2/role/module/delmodule', request);
    return Service.handleCommonError(data)
}